import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { useNavigate } from "react-router-dom";

const StateList = (props: any) => {
  const navigate = useNavigate();
  const { handleIsActive } = props;
  const handleRowClick = (row: any) => {
    navigate(`edit/${row.original.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Country",
      accessorKey: "district_name.name",
      cell: NACell,
    },
    {
      header: "Total District",
      accessorKey: "total_state",
      cell: NACell,
    },
    {
      header: "Total Cities",
      accessorKey: "total_district",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsActive}
          />
        </div>
      ),
    },
    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //       <AccessControl
    //         children={<TableActionButton editPath={`edit/${getValue()}`} />}
    //         allowedPermissions={["can_update_setting"]}
    //       />
    //     </>
    //   ),
    // },
  ];

  return (
    <DataTable
      url={`${APIS.LOCATION}flat-location`}
      queryKey={"state"}
      columns={defaultColumns}
      params={{ level: 1 }}
      addNewPagePath={"/create-state"}
      tableName={"state"}
      onRowClick={handleRowClick}
    />
  );
};

export default StateList;
